export const PrescriptionTagColors = {
  ACNE: "orange",
  EDYS: "green",
  PREP: "yellow",
  SCCM: "blue",
};
